<template>
    <section class="section my-6">
        <div class="container is-flex is-hidden-mobile">
            <h2 class="is-size-3 has-text-weight-bold is-family-secondary mx-3" style="max-width: 15rem" :style="computedFont">{{ configs.title }}</h2>
            <div class="cp-line-lv mx-6" :style="computedPrimary"></div>
            <p class="mx-6" style="max-width: 43rem">{{ configs.description }}</p>
        </div>
        
        <!-- show only mobile -->
        <div class="container has-text-justified is-hidden-tablet">
            <h2 class="is-size-3 has-text-weight-bold is-family-secondary mx-3 has-text-centered" :style="computedFont">{{ configs.title }}</h2>
            <div class="is-flex cp-line-lv my-2" :style="computedPrimary"></div>
            <p style="max-width: 43rem">{{ configs.description }}</p>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        configs: {
            required: true,
            type: Object,
        },
    },
    computed: {
        ...mapGetters({
            styles: 'company/landing_page_colors',

        }),
        computedFont(){
            return {
                'color': this.styles.title_color,
            }
        },
        computedPrimary(){
            return {
                'background-color': this.styles.title_color,
            }
        },
    },
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
 }

</style>